import React from "react";
import "./Volunteer.css";
import Footer from "../components/Footer";

const volunteerOpportunities = [
  {
    id: 1,
    title: "Community Outreach Volunteer",
    description:
      "Assist in organizing awareness programs on social issues, including health, hygiene, and education.",
    status: "Closed",
  },
  {
    id: 2,
    title: "Relief Distribution Volunteer",
    description:
      "Help in distributing relief materials to people affected by natural disasters such as floods and earthquakes.",
    status: "Closed",
  },
  {
    id: 3,
    title: "Women Empowerment Volunteer",
    description:
      "Participate in awareness seminars on women’s rights and contribute to skill development workshops.",
    status: "Closed",
  },
];

const Volunteer = () => {
  return (
    <>
      <div className="volunteer-container">
        {/* Hero Section */}
        <section className="volunteer-hero">
          <h1>Join as a Volunteer</h1>
          <p>
            At <strong>Development Education & Welfare Trust</strong>, we believe
            in the power of collective action. Volunteers are the heart of our
            initiatives, helping us create sustainable social impact.
          </p>
        </section>

        {/* Volunteer Details */}
        <section className="volunteer-details">
          <h2>Volunteer Opportunities</h2>
          <p className="volunteer-note">
            Currently, all volunteer opportunities are closed. Please check back
            later for updates.
          </p>

          <div className="volunteer-grid">
            {volunteerOpportunities.map((opportunity) => (
              <div className="volunteer-card closed" key={opportunity.id}>
                <h3>{opportunity.title}</h3>
                <p>{opportunity.description}</p>
                <span className="status">{opportunity.status}</span>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Footer */}
      <div className="footer-container">
        <Footer />
      </div>
    </>
  );
};

export default Volunteer;
